module.exports = __webpack_public_path__ + "img/Sunmerry.01be446e.svg";